import {ChangeDetectionStrategy, Component, inject, Input} from '@angular/core';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {faCheck, faMinus} from '@fortawesome/free-solid-svg-icons';
import {ICON_STYLE_DEFAULTS} from '../icon-style';

@Component({
    selector: 'app-true-false',
    templateUrl: './true-false.component.html',
    styleUrls: ['./true-false.component.scss'],
    standalone: true,
    imports: [FontAwesomeModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrueFalseComponent {
    @Input() value = false;

    protected readonly faCheck = faCheck;
    protected readonly faMinus = faMinus;

    protected readonly iconStyleResolved: 'bootstrap' | 'fontawesome' =
        inject(ICON_STYLE_DEFAULTS, {optional: true})?.iconStyle === 'fontawesome'
            ? 'fontawesome'
            : 'bootstrap';
}
